import { createSelector } from 'reselect';
import columns from '../../../../../react-table/helpers/columns';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';
import { monthYearColumns } from '../../component/ResdesManagementSummaryEpgMetadataMapper';

export const getData = ReportsDefinition.RESDES_MANAGEMENT_SUMMARY_EPG.getDataFunction();

const getMetadata = state => state.reporting.RESDES_MANAGEMENT_SUMMARY_EPG.metadata;

export const getGeneratedOnDateTime = state =>
  getMetadata(state) && getMetadata(state).generatedOnDateTime;

export const getIsLoading = state => state.reporting.RESDES_MANAGEMENT_SUMMARY_EPG.isLoading;

export function getPropsForPercentage() {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      if (rowInfo.original.pctPerformance <= 100 && rowInfo.original.pctPerformance >= 97) {
        className = 'bg-through-dark-green';
      } else if (rowInfo.original.pctPerformance <= 96.9 && rowInfo.original.pctPerformance >= 95) {
        className = 'bg-through-dark-yellow';
      } else if (rowInfo.original.pctPerformance <= 95 && rowInfo.original.pctPerformance !== null) {
        className = 'bg-through-dark-red';
      }
    }
    return {
      className,
    };
  });
}

export const getColumns = createSelector(getMetadata, getData, (metadata, data) => {
  if (!metadata || !metadata.columns) {
    return [];
  }

  const { TextColumn, NonZeroNumberColumn } = columns(data);

  if (data.length !== 0) {
    return [
      {
        Header: '',
        columns: [
          new TextColumn('Inbound EPG operator', 'inboundEpgOperator').withTotalHeaderEpg(data[0] !== undefined ? data[0].inboundEpgOperator : '', '', data[1].inboundEpgOperator),
          new TextColumn('Operator', 'operator').withTotalHeaderEpg(data[0] !== undefined ? data[0].operator : '', '', data[1].operator),
          new NonZeroNumberColumn('Links', 'links').withTotalHeaderEpg(data[0] !== undefined ? data[0].links : '', '', data[1].links),
          new TextColumn('Perf. % by objective', 'performance').withTotalHeaderEpg(data[0] !== undefined ? data[0].performance : '', '', data[1].performance, data[1]).withGetProps(getPropsForPercentage()),
          new NonZeroNumberColumn('Rank', 'rank').withTotalHeaderEpg(data[0] !== undefined ? data[0].rank : '', '', data[1].rank),

        ],
      }, ...monthYearColumns(metadata.columns.slice(5), data),
    ];
  }
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Inbound EPG operator', 'inboundEpgOperator'),
        new TextColumn('Operator', 'operator'),
        new NonZeroNumberColumn('Links', 'links'),
        new TextColumn('Perf. % by objective', 'performance'),
        new NonZeroNumberColumn('Rank', 'rank'),

      ],
    },
  ];
});
